import { api } from './api';
import { IRecognizeSensor } from 'entities/view/sensorDetails';

const basePath = '/api/v1/users';

export const getList = (query = '') =>
  api.get<IRecognizeSensor>(`${basePath}${query}`);

export const getDashboard = (id: number | string) =>
  api.get(`${basePath}/${id}/hierarchy`);
